export enum FilesActionTypes {
  GET_FILE = 'GET_FILE',
  GET_WATERMARKED_FILE = 'GET_WATERMARKED_FILE',
  CANCEL_ALL_WATERMARKED_REQUEST_PENDING = 'CANCEL_ALL_WATERMARKED_REQUEST_PENDING'
}